<template>
  <vue-perfect-scrollbar class="live-map-vessels-list">
    <div class="search-container">
      <b-input class="search-input" v-model="searchValue" placeholder="Search" />
      <b-button class="search-clear"
                variant="outline-secondary"
                @click="() => {this.searchValue = ''}">
        &times;
      </b-button>
    </div>

    <div v-for="(vessel, vIndex) in vesselsFormatted"
         :key="`vessel-${vIndex}`"
         :id="`vessel-${vessel.imo}`"
         class="vessel"
         :class="{'vessel-selected': vessel.imo === selectedVesselInternal}" >

      <div @click="toggleSelectedVessel(vessel)" class="vessel__header">
        <div>{{ vessel.vesselName }}</div>
        <div>{{ vessel.imo}}</div>
      </div>

      <div v-if="selectedVesselInternal === vessel.imo" class="vessel__details">
        <div v-for="(fieldName, rIndex) in Object.keys(vesselDetails)" :key="`row-${vIndex}-${rIndex}`" class="details-row">
          <div>{{ fieldName }}</div>
          <div>{{ vesselDetails[fieldName] }}</div>
        </div>
      </div>

    </div>
  </vue-perfect-scrollbar>
</template>

<script>
import some from 'lodash-es/some';
import { getFormattedVesselData } from '@/shared/api_formatters/vessels';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import isEmpty from 'lodash-es/isEmpty';
import getNested from 'lodash-es/get';
import { mapActions, mapGetters, mapMutations } from 'vuex';


export default {
  name: 'LiveMapVesselsList',

  components: {
    VuePerfectScrollbar,
  },

  props: {
    selectedVesselDetails: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      selectedVesselInternal: null,
      searchValue: '',
    };
  },

  mounted() {
    this.selectedVesselInternal = this.selectedVessel;
    this.$nextTick(() => {
      this.scrollVesselDetailsIntoView(this.selectedVessel);
    });
  },

  methods: {
    ...mapMutations('map', ['setSelectedVesselIMO']),
    ...mapActions('map', ['openVesselPopup']),

    toggleSelectedVessel(vessel) {
      if(this.selectedVesselInternal === vessel.imo) {
        this.selectedVesselInternal = null;
      } else {
        this.selectedVesselInternal = vessel.imo;
      }

      this.setSelectedVesselIMO(this.selectedVesselInternal);
      this.openVesselPopup(this.selectedVesselInternal);  // by the map store
    },

    scrollVesselDetailsIntoView(vesselIMO) {
      const element = document.querySelector(`#vessel-${vesselIMO}`);
      if(element) {
        element.scrollIntoView({block: 'center', behavior: 'smooth'});
      }
    },
  },

  computed: {
    ...mapGetters('map', ['visibleVessels']),

    selectedVessel() {
      return getNested(this.$store, 'state.map.selectedVesselIMO', null);
    },

    vesselsFormatted() {
      if(this.searchValue) {
        let vessels = [];

        for(let vessel of this.visibleVessels.values()) {
          const conditions = [
            vessel.vesselName.toLowerCase().indexOf(this.searchValue) !== -1,
            String(vessel.imo).indexOf(this.searchValue) !== -1,
          ];
          if(some(conditions)) {
            vessels.push(vessel);
          }
        }
        return vessels;
      } else {
        return Array.from(this.visibleVessels.values());
      }
    },

    vesselDetailsBasic() {
      const vessel = this.vesselsFormatted.find(item => item.imo === this.selectedVesselInternal);
      return getNested(vessel, 'popupData', {'Empty data': '--'});
    },

    vesselDetails() {
      if(isEmpty(this.selectedVesselDetails)) {
        return this.vesselDetailsBasic;
      }

      if(this.selectedVesselDetails.imo === this.selectedVesselInternal) {
        return getFormattedVesselData(this.selectedVesselDetails);
      } else {
        return this.vesselDetailsBasic;
      }
    },
  },

  watch: {
    selectedVessel(vesselIMO) {
      this.selectedVesselInternal = vesselIMO;
      this.$nextTick(() => {
        this.scrollVesselDetailsIntoView(vesselIMO);
      });
    },

    visibleVessels() {
      if(this.selectedVesselInternal) {
        this.$nextTick(() => {
          this.scrollVesselDetailsIntoView(this.selectedVesselInternal);
        });
      }
    },
  },
}
</script>

<style>
/* styles:*/
/* src/assets/scss/components/live_map/vessels_list.scss*/
</style>